import ReactSelect, { components } from "react-select";
import React, { forwardRef, useState, useEffect, useMemo, useImperativeHandle } from "react";

const ControlComponent = props => (
    <div className={"select-wrapper select-wrapper--" + props.selectProps.selectName}>
        <label id={"label-" + props.selectProps.selectName} className={props.selectProps.isLabelVisible ? "visible" : ""}>{props.selectProps.selectLabel}</label>
        <components.Control {...props} />
    </div>
);

const selectStyles = {
    control: (base) => ({
        ...base,
        boxShadow: "none",
        '&:hover': {
        }
    }),
    indicatorSeparator: (base, state) => {
        let additions = {};
        if (state.selectProps.showError) {
            additions.display = 'none';
        }
        return {
            ...base,
            ...additions
        }
    }
};

const formatOptionLabel = ({ value, label }) => (
    <span>
        <span className="checkbox"><span className="tick"></span></span>
        {label}
    </span>
);

/**
 * Select component used for filters in finder_mode
 * 
 * @param {*} props 
 * @returns 
 */
const CustomSelectR = forwardRef((props, ref) => {

    const [isSelectFocused, setSelectFocused] = useState(false);

    const {
        error,
        selectedValue,
        onSelect,
        onAutoSelect,
        selectName,
        selectLabel,
        selectOptions,
        withAutoSelect = false,
        isMulti = false,
        placeholder
    } = props;


    const handleOnFocus = (e) => {
        setSelectFocused(true);
    }

    const handleOnBlur = e => {
        setSelectFocused(false);
    }

    useImperativeHandle(ref, () => ({
        resetValue: () => {
            // Clear selected option
            onAutoSelect(selectName, null);
        }
    }));

    /**
     * handler for selection change
     * @param {*} option selected option(s)
     */
    const handleOnChange = (options) => {

        let values = null;

        if (Array.isArray(options)) {
            values = options.map(selection => selection.value);
        }
        else {
            values = options?.value;
        }

        setSelectFocused(false);
        onSelect(selectName, values);
    };


    /**
     * finds options by value
     * 
     * @param {*} value 
     * @param {*} options 
     * @returns a single or an array of options
     */
    const findOptionsByValue = (value, options) => {

        let selected = null;

        if (value && options.length) {
            if (Array.isArray(value)) {
                selected = options.filter(option => value.includes(option.value));
            } else {
                selected = options.find(option => option.value === value);
            }

        }

        return selected
    }


    /**
     * set autoselect option if only one option is available
     */ 
    useEffect(() => {
        if (!selectedValue && withAutoSelect && selectOptions.length === 1) {
            console.debug("Auto-selecting option for", selectName, selectOptions[0]);
            onSelect(selectName, selectOptions[0].value);
        }

    }, [selectedValue, selectOptions]);


    /**
     * Memoized function to find selected options based on the selected value and available options.
     */
    const selectedOptions = useMemo(() => {

        let selected = findOptionsByValue(selectedValue, selectOptions);

        if (!selected && withAutoSelect && selectOptions.length === 1) {
            selected = selectOptions[0];
        }

        return selected;

    }, [selectedValue, selectOptions]);

    const isLabelVisible = (() => isSelectFocused || !!selectedOptions)();

    return (
        <ReactSelect
            {...props}
            value={selectedOptions}
            className={"react-select-container select-" + selectName + (isMulti ? " select-multi" : "") + (error ? " error" : "")}
            classNamePrefix="react-select"
            onFocus={handleOnFocus}
            onBlur={handleOnBlur}
            aria-labelledby={"label-" + selectName}
            placeholder={placeholder ? placeholder : selectLabel}
            options={selectOptions}
            isLabelVisible={isLabelVisible}
            onChange={handleOnChange}
            components={{ Control: ControlComponent }}
            hideSelectedOptions={false}
            formatOptionLabel={isMulti ? formatOptionLabel : ""}
            styles={selectStyles} />
    );
});

export default CustomSelectR;